import type { EmsComponents, NormalizedNullableResponse } from '../../api/ems';
import { normalizeLocation } from './location';
import type { Location } from './location';

export type PortalCallWire = EmsComponents['schemas']['PortalCall'];

export type DataSourceKind = PortalCallWire['sourceKinds'][number];

export type PortalCall = Omit<NormalizedNullableResponse<PortalCallWire>, 'lastLocation'> & {
  lastLocation: Location | null;
};

export function normalizePortalCall(call: PortalCallWire): PortalCall {
  return {
    ...call,
    endedAtUtc: call.endedAtUtc ?? null,
    lastLocation: call.lastLocation == null ? null : normalizeLocation(call.lastLocation),
  };
}
